import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang, useModel } from '@umijs/max';
import { Switch, Tooltip } from 'antd';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};

// 主题切换（封装自 app.tsx 中的 Switch 逻辑）
export const ThemeSwitcher: React.FC = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const isDark = initialState?.settings?.navTheme === 'realDark';

  return (
    <div>
      <Tooltip title={isDark ? '切换为亮色主题' : '切换为暗色主题'}>
        <Switch
          checkedChildren="🌜"
          unCheckedChildren="🌞"
          checked={isDark}
          onChange={(checked) => {
            setInitialState((s) => ({
              ...s,
              settings: {
                ...(s?.settings || {}),
                navTheme: checked ? 'realDark' : 'light',
              },
            }));
          }}
        />
      </Tooltip>
    </div>
  );
};
